// This is mainly being used in the Call logs histogram for selecting a date range from the chart itself

// TODO: Use the timezone passed in from the chart options to format the selection shown
import moment from 'moment';

const FADE_TIMEOUT = 2000;
const FADE_OUT_SPEED = 10;

function formatTime(timeInEpoch, offset) {
  return moment.utc(timeInEpoch + (offset * 60 * 1000)).format('D MMM H:mm:ss');
}

export default function (Highcharts) {
  Highcharts.wrap(Highcharts.Pointer.prototype, 'drag', function (p, e) {
    p.call(this, e);

    const chart = this.chart;
    if (!chart || !chart.options.chart.showDragPoints || !chart.options.chart.showDragPoints.enable) {
      return;
    }

    const selectionMarker = this.selectionMarker;
    let bBox,
      xAxis,
      labelLeft,
      labelRight,
      labelY,
      attr,
      css;
    const offsetInMinutes = chart.options.chart.showDragPoints.offsetInMinutes;

    if (selectionMarker) {
      if (!chart.customLabels) {
        chart.customLabels = [];
        chart.customLabelTimers = [];
      }

      bBox = selectionMarker.getBBox();
      xAxis = chart.xAxis[0];
      labelLeft = chart.customLabels[0];
      labelRight = chart.customLabels[1];
      labelY = chart.plotTop + 10;

      if (!labelLeft || !labelRight) {
        attr = {
          fill: Highcharts.getOptions().colors[0],
          padding: 10,
          r: 5,
          zIndex: 8
        };

        css = {
          color: '#000'
        };

        labelLeft = chart.renderer
          .label('', 0, 0)
          .attr(attr)
          .css(css)
          .add();
        labelRight = chart.renderer
          .label('', 0, 0)
          .attr(attr)
          .css(css)
          .add();

        chart.customLabels.push(labelLeft, labelRight);
      }

      clearTimeout(chart.customLabelTimers[0]);
      clearTimeout(chart.customLabelTimers[1]);

      labelLeft.attr({
        x: bBox.x - labelLeft.getBBox().width,
        y: labelY,
        text: 'From: ' + formatTime(Math.round(xAxis.toValue(bBox.x)), offsetInMinutes),
        opacity: 1,
        visibility: 'visible'
      });

      labelRight.attr({
        x: bBox.x + bBox.width,
        y: labelY,
        text: 'To: ' + formatTime(Math.round(xAxis.toValue(bBox.x + bBox.width)), offsetInMinutes),
        opacity: 1,
        visibility: 'visible'
      });

      chart.customLabelTimers[0] = setTimeout(() => {
        labelLeft.fadeOut(FADE_OUT_SPEED);
      }, FADE_TIMEOUT);

      chart.customLabelTimers[1] = setTimeout(() => {
        labelRight.fadeOut(FADE_OUT_SPEED);
      }, FADE_TIMEOUT);
    }
  });
}